
<template>
    <li>
        <a :href="list._href"><span>{{ list.name }}</span></a>
    </li>
</template>
<script>
export default {
  data() {
    return {
      // list of tags for giving each schools a different color - maybe a feature later
    };
  },

  props: {
    // this component expects a prop of type object
    list: Object
  },
  filters: {
    // this filter is used to capitalize the name
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AcademicList.vue